<template>
    <div class="wrapper">
        <div class="spinnerWrapper">
            <b-spinner class="mapSpinner" label="Large Spinner" type="grow"></b-spinner>
            <b-spinner class="mapSpinner second" label="Large Spinner" type="grow"></b-spinner>
            <b-spinner class="mapSpinner third" label="Large Spinner" type="grow"></b-spinner>
        </div>
    </div>
</template>

<script lang="ts">

    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component({
        name: 'map-loader'
    })

    export default class ContextMenu extends Vue {
    }

</script>

<style scoped>
    .wrapper {
        position: absolute;
        height: inherit;
        width: 100%;
        background-color: rgba(92, 133, 177, 0.30);
        z-index: 100000;
        display: flex;
    }
    .spinnerWrapper {
        height: inherit;
        width: 100%;
        margin: auto;
    }

    .mapSpinner {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: block;
        width: 15rem;
        height: 15rem;
        animation-delay: 250ms;
        animation-duration: 2500ms;
        animation-timing-function: ease-out;
    }

    .second {
        animation-delay: 1000ms;
        animation-timing-function: ease-out;
        color: #93c01f;
    }

    .third {
        animation-delay: 1500ms;
        animation-timing-function: ease-out;
        color: #17a2b8;
    }
</style>